import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { saveReportTemplateDomain } from "./reportTemplateActions";
import { GetReportTemplateDomain } from "./reportTemplateTypes";

// Api's
import { reportTemplateApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getReportTemplateDomainSaga(action: GetReportTemplateDomain) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(reportTemplateApi.getDomain, action.payload.request);
		if (response.data.result) {
			yield put(saveReportTemplateDomain(response.data.result, false, null, action.payload.keyReducer));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveReportTemplateDomain(null, true, resultError.messagesDataError, action.payload.keyReducer));
		}
	}
}
